<div class="video-page">
  <!-- ── Onboarding overlay ─────────────────────────────────────── -->
  @if (status() === "onboarding") {
    <div class="onboarding-overlay">
      <div class="onboarding-card">
        <button class="back-link" type="button" (click)="home()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back
        </button>

        <div class="brand">
          <span class="live-dot"></span> {{ appName }} Video
        </div>

        <h1>Video Chat with Strangers</h1>
        <p class="subtitle">
          Face-to-face, anonymous, instant. No account needed.
        </p>

        <div class="field">
          <label for="vname">Your nickname</label>
          <input
            id="vname"
            type="text"
            maxlength="30"
            placeholder="Enter a nickname"
            [value]="displayName()"
            (input)="displayName.set($any($event.target).value)"
          />
        </div>

        <div class="field">
          <label
            >Interests
            <span class="optional"
              >(optional &mdash; helps match you better)</span
            ></label
          >
          <div class="interest-chips">
            @for (interest of interests; track interest) {
              <button
                type="button"
                class="chip"
                [class.selected]="selectedInterests().includes(interest)"
                (click)="toggleInterest(interest)"
              >
                {{ interest }}
              </button>
            }
          </div>
        </div>

        <button class="start-btn" type="button" (click)="completeOnboarding()">
          Start Video Chat
        </button>

        <p class="consent">
          By continuing you confirm you are 18+ and agree to our
          <a href="/community-guidelines" target="_blank"
            >community guidelines</a
          >.
        </p>
      </div>
    </div>
  }

  <!-- ── Main video view ────────────────────────────────────────── -->
  @if (status() !== "onboarding") {
    <div class="video-view">
      <!-- Top bar -->
      <div class="video-header">
        <button class="logo-btn" type="button" (click)="home()">
          {{ appName }}
        </button>

        @if (status() === "connected") {
          <div class="peer-info">
            <span class="peer-dot"></span>
            <span class="peer-name">{{ name() }}</span>
            @if (country()) {
              <span class="peer-country">{{ country() }}</span>
            }
          </div>
        }
      </div>

      <!-- Video streams + status overlay -->
      <div class="streams-area">
        <app-video-streams
          [localStream]="webrtc.localStream()"
          [remoteStream]="webrtc.remoteStream()"
        >
        </app-video-streams>

        @if (status() !== "connected") {
          <app-video-status [status]="status()" (cancel)="cancelSearch()">
          </app-video-status>
        }
      </div>

      <!-- Controls bar -->
      <div class="controls-bar">
        <app-video-controls
          [isMuted]="webrtc.isMuted()"
          [isCameraOff]="webrtc.isCameraOff()"
          [isConnected]="status() === 'connected'"
          (toggleMute)="webrtc.toggleMute()"
          (toggleCamera)="webrtc.toggleCamera()"
          (skip)="skip()"
          (end)="end()"
        >
        </app-video-controls>
      </div>
    </div>
  }
</div>
